module.exports = __webpack_public_path__ + "img/upload-04.f28ccc7c.svg";